import { IconName } from '@infotech-soe/erp-ui-kit';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

class ReviewRecordCommand extends CategoryCommand<any> {
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.REVIEW,
    };
  }

  public getIcon(): IconName {
    return 'file-view';
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.NONE;
  }
}

export default ReviewRecordCommand;
